import React from "react";
import { Check, AlertTriangle, X } from "lucide-react";
import { Reveal, SectionHeading } from "../Reveal";
import { comparisonRows } from "../../mock";

const negativeWords = ["limited", "not", "requires", "generic", "multi-industry", "template", "add-on", "external", "moderate", "medium", "basic"];

const CellMark = ({ value, highlight = false }) => {
  const v = value.toLowerCase();
  const isNegative = !highlight && negativeWords.some((w) => v.includes(w));
  if (highlight) {
    return (
      <span className="flex items-start gap-2 text-sm font-medium text-cyan-100">
        <Check className="mt-0.5 h-4 w-4 shrink-0 text-cyan-400" /> {value}
      </span>
    );
  }
  if (isNegative) {
    const hard = v.includes("not") || v.includes("generic") || v.includes("requires");
    return (
      <span className="flex items-start gap-2 text-sm text-slate-400">
        {hard ? <X className="mt-0.5 h-4 w-4 shrink-0 text-red-400/80" /> : <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0 text-amber-400/80" />}
        {value}
      </span>
    );
  }
  return (
    <span className="flex items-start gap-2 text-sm text-slate-300">
      <Check className="mt-0.5 h-4 w-4 shrink-0 text-slate-500" /> {value}
    </span>
  );
};

const ComparisonSection = ({ compact = false }) => {
  const rows = compact ? comparisonRows.slice(0, 8) : comparisonRows;
  return (
    <section id="why-us" className="relative py-24 lg:py-32">
      <div className="bg-radial-glow absolute inset-0 opacity-50" />
      <div className="relative mx-auto max-w-6xl px-5 lg:px-8">
        <SectionHeading
          eyebrow="Why Arkision"
          title={<>The strategic <span className="text-cyan-400">comparison</span></>}
          sub="Purpose-built for hospitals — not a generic voice platform retrofitted for healthcare."
        />

        <Reveal>
          <div className="card-dark overflow-hidden rounded-3xl">
            <div className="overflow-x-auto">
              <table className="w-full min-w-[720px] text-left">
                <thead>
                  <tr className="border-b border-white/10 bg-white/[0.03]">
                    <th className="px-6 py-4 text-xs font-semibold uppercase tracking-widest text-slate-400">Capability</th>
                    <th className="border-x border-cyan-400/20 bg-cyan-400/[0.07] px-6 py-4 text-xs font-semibold uppercase tracking-widest text-cyan-300">
                      Arkision AI
                    </th>
                    <th className="px-6 py-4 text-xs font-semibold uppercase tracking-widest text-slate-400">Generic Global Platform</th>
                  </tr>
                </thead>
                <tbody>
                  {rows.map((r, i) => (
                    <tr key={r.capability} className={`transition-colors hover:bg-white/[0.02] ${i !== rows.length - 1 ? "border-b border-white/5" : ""}`}>
                      <td className="px-6 py-3.5 text-sm font-medium text-slate-200">{r.capability}</td>
                      <td className="border-x border-cyan-400/15 bg-cyan-400/[0.04] px-6 py-3.5"><CellMark value={r.arkision} highlight /></td>
                      <td className="px-6 py-3.5"><CellMark value={r.global} /></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default ComparisonSection;
